var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoading)?_c('span',[_vm._v("Please wait...")]):_vm._e(),(!_vm.isLoading)?_c('remaining-balance',{attrs:{"userId":_vm.userId,"organizationId":_vm.organizationId,"unauth":true}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }